import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import Input from '../../components/Input'
import axiosClient from '../../axios'
import toast from 'react-hot-toast'
import { MdLogin } from 'react-icons/md'
import { FaBarcode } from 'react-icons/fa6'
import { FaBirthdayCake } from 'react-icons/fa'

export default function Login({ handleResult }) {
  const [loading, setLoading] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setFocus,
  } = useForm()

  const onSubmit = async (data) => {
    setLoading(true)
    const { kitId, retrievalCode, patientDoB } = data
    try {
      const response = await axiosClient.post(`kits/${kitId}/results`, { resultRetrievalCode: retrievalCode, patientDoB })

      if (response.data?.labTestResult) {
        setLoading(false)
        handleResult(response.data.labTestResult)
        toast.success('Test results retrieved successfully!')
      }
    } catch (error) {
      setLoading(false)
      console.log(error?.response?.data.errorMessage ?? error)
      toast.error(error?.response?.data.errorMessage ?? 'Something went wrong! Please try again.',
        {
          duration: 6000
        }
      )
    }
  }

  useEffect(() => {
    let hash = window.location.hash

    if (hash) {
      hash = hash.replace(/^#/, '')
      try {
        const initialData = JSON.parse(atob(hash))

        setValue('kitId', initialData.kitId)
        setValue('retrievalCode', initialData.resultRetrievalCode)
        setFocus('patientDoB')
      } catch (e) {
        console.log(e)
      }
    }

    return () => {}
  }, [setFocus, setValue])

  return loading ? (
    <div className="loader"></div>
  ) : (
    <form className="requestResultForm">
      <h1>Request Test Results</h1>
      <Input
        id={'kitId'}
        type={'number'}
        label={'Kit Id'}
        icon={<MdLogin />}
        placeholder={'00000000'}
        register={{ ...register('kitId', { required: true, pattern: /^[0-9]{6,10}$/ }) }}
        error={
          errors?.kitId?.type === 'required'
            ? 'This field is required'
            : errors?.kitId?.type === 'pattern'
            ? 'Please enter at least 6 digits'
            : ''
        }
      />

      <Input
        id={'retrievalCode'}
        type={'text'}
        icon={<FaBarcode />}
        label={'Retrieval Code'}
        placeholder={'ABC123'}
        register={{ ...register('retrievalCode', { required: true, pattern: /^[0-9A-Za-z]{6}$/ }) }}
        error={
          errors?.retrievalCode?.type === 'required'
            ? 'This field is required'
            : errors?.retrievalCode?.type === 'pattern'
            ? 'Please enter 6 characters (A-Z and 0-9)'
            : ''
        }
      />

      <Input
        id={'patientDoB'}
        icon={<FaBirthdayCake />}
        type={'number'}
        label={'Patient Date of Birth'}
        placeholder={'YYYYMMDD'}
        register={{ ...register('patientDoB', { required: true, pattern: /^[0-9]{8}$/ }) }}
        error={
          errors?.patientDoB?.type === 'required'
            ? 'This field is required (YYYYMMDD)'
            : errors?.patientDoB?.type === 'pattern'
            ? 'Please enter 8 digits (YYYYMMDD)'
            : ''
        }
      />

      <button onClick={handleSubmit(onSubmit)}>Submit</button>
    </form>
  )
}
